module.exports = __webpack_public_path__ + "img/scenario_06.592a3a2e.jpg";